import { TaggableEntityType } from "@daytrip/legacy-enums";
import { isUndefinedOrNull } from "@daytrip/utils";
import { Expose, Transform } from "class-transformer";
import { IsDefined, IsString, IsUUID, IsEnum, ValidateIf, ArrayNotEmpty } from "class-validator";
import { v4 as uuid } from "uuid";

import { CDBaseEntity, CDColumn, CDEntity, CDObjectIdColumn } from "../orm";

@CDEntity("tags")
export class Tag extends CDBaseEntity {
    @CDObjectIdColumn()
    @IsUUID("4")
    @Expose()
    public _id: string = uuid();

    // @IsUUID("4")
    @CDColumn()
    @Expose()
    @Transform((value) => (isUndefinedOrNull(value) ? null : value))
    public parentTagId: string | null;

    @CDColumn()
    @IsString()
    @IsDefined()
    @Expose()
    public title: string;

    @CDColumn()
    @IsString()
    @Expose()
    @ValidateIf((tag: Tag) => !isUndefinedOrNull(tag.description))
    public description?: string;

    @CDColumn()
    @Expose()
    @ArrayNotEmpty()
    @IsEnum(TaggableEntityType, { each: true })
    public applicableFor: string[];
}
